const list = {
  user: 'users',
  customer: 'customers',
  property: 'properties',
  enterprise: 'enterprises',
};

export default list;
